// Redux
import {useSelector, useStore, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';

// Selectors
import {hotelsPartnerFn} from '@stencil/hotels-common-reducer/src/selectors';

// Utils
import {getRoomRelatedInfoForReviewPage} from '@stencil/hotels-utils/src/common-utils';
import getCgReviewPageUrl from '@stencil/hotels-utils/src/get-cg-review-page-url';
import {parseDate} from '@stencil/hotels-utils/src/date-utils/date-utils';
import {
  resetValidateCouponData,
  resetAvailRoomsData,
} from '@stencil/hotels-cg-reducer/src/review/actions';
import {getLocusUrlParam} from '@stencil/hotels-utils/src/get-locus-url-string';
import {NavigatorNewShape} from '@stencil/hotels-types/src/common/types';

export default function useNavigateToReviewPage() {
  const store = useStore();
  const history = useHistory();
  const dispatch = useDispatch();
  const state = store.getState();
  const {detailsUnif, common} = state;
  let {
    country,
    pokusExpData,
    checkin,
    checkout,
    destination,
    roomString,
    locus,
    selectedHotel = {},
    topHtlId,
    sType,
  } = common;
  const partner = useSelector(hotelsPartnerFn);

  const navigatorNew = ({
    selectedRoomInfo = [
      {
        ratePlanArr: [],
        roomLevelInfo: {
          roomCode: '',
          roomCount: 0,
        },
      },
    ],
    rootLevelInfo = {
      searchType: '',
      isQuickBook: false,
      promoCode: '',
      fcSlotId: null,
    },
  }: NavigatorNewShape) => {
    const {roomCriteria, payMode} = getRoomRelatedInfoForReviewPage({
      selectedRooms: selectedRoomInfo,
      isMultiRoom: rootLevelInfo?.searchType?.toUpperCase() === 'O',
    });

    let reviewUrl = '';

    const locusParams = getLocusUrlParam(locus);

    reviewUrl = getCgReviewPageUrl(
      {
        _uCurrency: 'INR',
        checkin: parseDate(checkin?.date, 'mmddyyyy'),
        checkout: parseDate(checkout?.date, 'mmddyyyy'),
        city: destination?.n,
        country,
        couponCode: rootLevelInfo?.promoCode,

        hotelId: detailsUnif?.searchRooms?.data?.hotelDetails?.hotelId,
        giHotelId: selectedHotel?.propertyId,
        locusId: locusParams?.locusId,
        locusType: locusParams?.locusType,
        fcSlotId: rootLevelInfo?.fcSlotId,
        roomCriteria: encodeURIComponent(roomCriteria),
        roomStayQualifier: '',

        vcid: destination?._id,
        roomString: roomString,
        luckyProperty: detailsUnif?.searchRooms?.data?.luckyData?.luckyProperty?.toString(),
        searchText: detailsUnif?.static?.hotelDetails?.name || selectedHotel?.propertyName,
        payMode: payMode,
        isQuickBook: rootLevelInfo?.isQuickBook,
        searchType: rootLevelInfo?.searchType,
        topHtlId,
        sType,
        // selectedRatePlanIndex: selectedRatePlanIndex,
      },
      partner,
    );
    console.log('navigatorNew reviewUrl::', reviewUrl);
    dispatch(resetValidateCouponData());
    dispatch(resetAvailRoomsData());

    history.push(reviewUrl);
  };

  return [navigatorNew];
}
